import "magnific-popup";

let personWrapper = document.querySelector('.person__wrapper');
if(personWrapper) {
    openPopupPerson();
}

function openPopupPerson() {
    personWrapper.addEventListener('click', (e) => {
        let target = e.target;
        if(target.closest('.person__item') !== null) {
            let currentElement = target.closest('.person__item');
            openPopup(currentElement, currentElement.getAttribute('data-id'));
        }
    })
}


function openPopup(el, id) {
    $.magnificPopup.open({
        items: {
            src: '#' + id,
        },
        type: 'inline',
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        // fixedContentPos: 'auto',
        fixedContentPos: true,
    });
}